module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/address/postcode.js
 ** module id = 475
 ** module chunks = 0
 **/